import { useState, useEffect } from 'react';
import { Event } from '../services/Types';
import { allEvents } from '../services/EventService';

// Global cache for event data
let myEventCache: Event[] = [];

// Global fetching state
let isFetching = false;

export const useMyEvents = (dateLimited?: string) => {
  const [myEvents, setMyEvents] = useState<Event[]>([]);
  const [errorUseMyEvents, setErrorUseMyEvents] = useState<string | null>(null);
  const [updatingMyEvents, setUpdatingMyEvents] = useState<boolean>(false);

  // TODO: The cache should be for each event so we can reset a single event
  const resetCache = () => {
    myEventCache = [];
    setMyEvents([]);
    getMyEvents();
  }

  // Fetch all events
  const getMyEvents = async () => {
    if (myEventCache.length > 0 && myEvents.length === 0) {
      setMyEvents(myEventCache);
      return true;
    }
    if (isFetching) {
      return true;
    }
    try {
      isFetching = true
      setUpdatingMyEvents(true)
      const userOnly = true;
      const { data } = await allEvents(dateLimited || "all", userOnly);
      if (data?.events?.data && data.events.statusCode === 200) {
        myEventCache = data.events.data;
        setMyEvents(data.events.data);
        setErrorUseMyEvents(null);
        return true;
      } else {
        setErrorUseMyEvents('Error fetching events. Please try again later.');
        return false;
      }
    } catch (error) {
      console.error('Error fetching events:', error);
      setErrorUseMyEvents('Error fetching events. Please try again later.');
      return false;
    } finally {
      isFetching = false
      setUpdatingMyEvents(false)
    }
  };
  useEffect(() => {
    getMyEvents();
  }, []);



  return {
    myEvents,
    errorUseMyEvents,
    updatingMyEvents,
    resetCache
  };
}; 